<template>
  <div class="page-account">
    <div class="page-account-header"></div>
    <div class="page-account-container">
      <SocialSign></SocialSign>
      <div class="xz-login">
        <el-form :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item prop="username" required>
            <el-input
              placeholder="请输入用户名"
              prefix-icon="el-icon-user"
              v-model="loginForm.username"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" required>
            <el-input
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              v-model="loginForm.password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item class="page-account-auto-login">
            <!-- <el-checkbox v-model="loginForm.autologin">自动登录</el-checkbox>
            <router-link to="/forget">忘记密码</router-link> -->
          </el-form-item>
          <el-form-item>
            <el-button
              class="bigbtn"
              type="primary"
              :loading="btLoading"
              @click="onSubmit('loginForm')"
              >立即登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <PageFooter></PageFooter>
  </div>
</template>
<script>
import SocialSign from "../components/social-sign.vue";
import { _setSessionStore, _getSessionStore } from "@/utils/storage";
import PageFooter from "../components/page-footer.vue";
import { login } from "../../api/user.js";
export default {
  name: "login",
  components: { SocialSign, PageFooter },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
        autologin: false
      },
      btLoading: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    onSubmit(loginForm) {
      let that = this;
      this.btLoading = true;
      let query = this.$route.query;
      this.$refs[loginForm].validate(valid => {
        if (valid) {
          login(this.loginForm)
            .then(res => {
              //设置token
              that.$store.dispatch("user/setToken", res.token);
              // 记住用户信息
              that.$store.dispatch("user/setUserInfo", res);
              _setSessionStore("userInfo", res.user, "JSONStr");
              sessionStorage.setItem(
                "auth_rule",
                JSON.stringify(res.auth_rule)
              );
              //权限菜单 TODO
              sessionStorage.setItem("token", res.token);
              sessionStorage.setItem("auth", JSON.stringify(res.auth));
              if (query["redirect"]) {
                this.$router.push(query["redirect"]);
              } else {
                window.location.href = process.env.BASE_URL || "/";
                console.log(res, "res-----1");
                // this.$router.push("/dashboard");0\
                // location.reload();
              }
              this.btLoading = false;
            })
            .catch(() => {
              this.btLoading = false;
            });
          return true;
        }
        this.btLoading = false;
        return false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page-account {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
}
.page-account-header {
  text-align: right;
  position: fixed;
  top: 16px;
  right: 24px;
}
.page-account-container {
  flex: 1;
  padding: 32px 0;
  text-align: center;
  width: 384px;
  margin: 0 auto;
}
.xz-login {
  .page-account-auto-login {
    margin-bottom: 24px;
    text-align: left;
  }
  .page-account-auto-login a {
    float: right;
  }
  .page-account-other {
    margin: 24px 0;
    text-align: left;
    img {
      width: 24px;
      margin-left: 16px;
      cursor: pointer;
      vertical-align: middle;
      opacity: 0.7;
      transition: all 0.2s ease-in-out;
    }
    .page-account-register {
      float: right;
    }
  }
}
</style>
